import { OktaAuth } from '@okta/okta-auth-js';
import Config from '../../config';

const oktaAuth = new OktaAuth({
  issuer: Config.okta.issuer,
  clientId: Config.okta.clientId,
  redirectUri: window.location.origin + '/callback',
});

const authenticateWithOktaPopup = async (): Promise<string> => {
  const tokenResponse = await oktaAuth.token.getWithPopup({});
  const { tokens } = tokenResponse;
  oktaAuth.tokenManager.setTokens(tokens);

  const accessToken = tokens.accessToken?.accessToken;
  if (!accessToken) {
    throw new Error('Okta authentication did not return an access token');
  }

  return accessToken;
};

// The token manager keeps tokens in synchronous storage, so this is the same read `get` does.
const getUnexpiredAccessToken = () => {
  const tokenManager = oktaAuth.tokenManager;
  const { accessToken } = tokenManager.getTokensSync();

  return accessToken && !tokenManager.hasExpired(accessToken) ? accessToken : undefined;
};

/** Reports whether there is already a usable Okta session, without prompting the user for one. */
const isOktaAuthenticated = (): boolean => !!getUnexpiredAccessToken();

/** Returns a usable access token, prompting the user to authenticate when there is not one. */
const getOktaAccessToken = async (): Promise<string> =>
  getUnexpiredAccessToken()?.accessToken ?? authenticateWithOktaPopup();

export { oktaAuth, getOktaAccessToken, isOktaAuthenticated };
